// extracted by mini-css-extract-plugin
var _1 = "PostActions-module__animateUploadProgressBarWidth--M8H84";
var _2 = "PostActions-module__animatedBackground--QMdQz";
var _3 = "PostActions-module__modeToggleContainer--dP49x";
var _4 = "PostActions-module__modeToggleSeparator--EnAe5";
var _5 = "PostActions-module__presenceContainer--F9fiP";
var _6 = "PostActions-module__statusContainer--uZ794";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "modeToggleContainer", _4 as "modeToggleSeparator", _5 as "presenceContainer", _6 as "statusContainer" }
